<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.refund-dialog /deep/ .el-dialog__header {
  text-align: center;
}

.refund-dialog .dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.required-star {
  color: red;
  margin-right: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">安心包598商品订单</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="handleRefund()">退 款</button>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="
          () => {
            showMultiQuerys = !showMultiQuerys;
          }
        ">
          高级筛选
        </button>
        <button class="common-bg-button" @click="handleExport()">导 出</button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyword" size="small" placeholder="请输入手机号"></el-input>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">购买类型</p>
              <el-select v-model="queryInfo.buyType" size="small" clearable placeholder="请选择购买类型" style="width: 100%">
                <el-option label="超省包598活动-用桩服务" value="AXB_598_ACTIVITY_PAY" />
                <!-- <el-option label="安心包598活动-待激活退出" value="AXB_598_ACTIVITY_PAY_REFUND" /> -->
                <el-option label="超省包598活动-使用中退出" value="AXB_598_ACTIVITY_PAY_ON_USE_REFUND" />
                <el-option label="超省包698活动-用桩服务" value="AXB_698_ACTIVITY_PAY" />
                <el-option label="超省包698活动-使用中退出" value="AXB_698_ACTIVITY_PAY_ON_USE_REFUND" />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款操作时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="refundTime" @change="pickRefundDate(refundTime)" range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 16px">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单状态</p>
              <el-select v-model="queryInfo.orderStatus" size="small" clearable placeholder="请选择订单状态"
                style="width: 100%">
                <el-option label="已支付" value="PAY" />
                <el-option label="退款中" value="TO_REFUND" />
                <el-option label="已退款" value="REFUND" />
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="getListData(pagination, true)">
            搜 索
          </button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          ">
        </ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>

      <!-- 服务类型选择弹窗 -->
      <el-dialog class="refund-dialog" title="请选择退款类型" :visible.sync="serviceTypeDialogVisible" width="30%">
        <el-form label-width="100px" size="small">
          <el-form-item label="退款类型:">
            <el-select v-model="selectedServiceType" placeholder="请选择退款类型" style="width: 100%">
              <el-option label="新499活动-用桩服务" value="USE_PILE" />
              <el-option label="新499活动-买断服务" value="BUYOUT" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="serviceTypeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmServiceType">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 退款弹窗 -->
      <el-dialog class="refund-dialog" title="退款金额确认" :visible.sync="dialogVisible" width="35%"
        @close="handleClose('refundForm')">
        <el-form ref="refundForm" :model="popFormInfo" :rules="rules" :hide-required-asterisk="true" label-width="150px"
          class="demo-ruleForm" size="small">
          <el-form-item label="退款支付宝账户:">
            <el-input v-model="popFormInfo.refundAlipayAccount" disabled />
          </el-form-item>
          <el-form-item label="订单名称:">
            <el-input v-model="popFormInfo.orderName" disabled />
          </el-form-item>
          <el-form-item prop="refundType">
            <template slot="label">
              <span class="required-star">*</span>退款类型:
            </template>
            <el-select v-model="popFormInfo.refundType" placeholder="请选择退款类型" style="width: 100%">
              <el-option label="全额退款" value="ALL" />
              <el-option label="部分退款" value="PART" />
              <el-option label="拒绝退款" value="REJECT" />
            </el-select>
          </el-form-item>
          <el-form-item prop="refundAmount" v-if="popFormInfo.refundType !== 'REJECT'">
            <template slot="label">
              <span class="required-star">*</span>退款金额:
            </template>
            <el-input-number v-model="popFormInfo.refundAmount" :min="0"
              :max="popFormInfo.maxRefundAmount || Number.MAX_SAFE_INTEGER" style="width: 100%" :step="1" />
          </el-form-item>
          <el-form-item prop="resetUse">
            <template slot="label">
              <span class="required-star">*</span>
              <span> 是否恢复服务使用:</span>
            </template>
            <el-select v-model="popFormInfo.resetUse" placeholder="请选择" style="width: 100%">
              <el-option label="是" value="Y" />
              <el-option label="否" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item prop="refundReason">
            <template slot="label">
              <span class="required-star">*</span>退款原因:
            </template>
            <el-select v-model="popFormInfo.refundReason" placeholder="请选择退款原因" style="width: 100%">
              <el-option label="平台测算" value="平台测算" />
              <el-option label="用户申请" value="用户申请" />
              <el-option label="其他" value="其他" />
            </el-select>
          </el-form-item>
          <el-form-item prop="refundRemark">
            <template slot="label">
              <span class="required-star">*</span>退款原因备注:
            </template>
            <el-input type="textarea" v-model="popFormInfo.refundRemark" placeholder="请输入退款原因备注" :rows="3" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose('refundForm')">取 消</el-button>
          <el-button type="primary" @click="makeSure('refundForm')">确认退款</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";

export default {
  data() {
    return {
      pageConfig: pageConfig,
      tableData: [],
      selections: [],
      pagination: { ...pageConfig.pagination },
      queryInfo: {},
      createTime: [],
      refundTime: [],
      showMultiQuerys: false,
      operates: { list: [] },
      dialogVisible: false,
      serviceTypeDialogVisible: false,
      selectedServiceType: "",
      popFormInfo: {
        refundAlipayAccount: "",
        custMobile: "",
        mapNo: "",
        cancelNo: "",
        actualAmount: 0,
        refundAmount: 0,
        maxRefundAmount: Number.MAX_SAFE_INTEGER,
        custAccount: "",
        cancelAmount: 0,
        refundType: "ALL",
        resetUse: "N",
        refundReason: "",
        refundRemark: "",
        orderName: "",
        activityOrderNo: "",
      },
      rules: {
        refundType: [{ required: true, message: "请选择退款类型", trigger: "change" }],
        refundAmount: [
          { required: true, type: "number", message: "请输入退款金额", trigger: "change" },
          {
            validator: (_, value, cb) => {
              if (value === undefined || value === null || value === "")
                return cb(new Error("请输入退款金额"));
              if (Number.isNaN(Number(value))) return cb(new Error("金额需为数字"));
              if (Number(value) < 0) return cb(new Error("金额不能小于0"));
              return cb();
            },
            trigger: ["blur", "change"],
          },
        ],
        resetUse: [{ required: true, message: "请选择是否恢复服务使用", trigger: "change" }],
        refundReason: [{ required: true, message: "请选择退款原因", trigger: "change" }],
        refundRemark: [{ required: true, message: "退款原因备注不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    init() {
      this.getListData(this.pagination, true);
    },
    cleanQueryInfo(queryInfo) {
      const clean = {};
      Object.keys(queryInfo).forEach((key) => {
        const value = queryInfo[key];
        if (value !== null && value !== undefined && value !== "") {
          clean[key] = value;
        }
      });
      return clean;
    },
    getListData(pagination, reload = false) {
      const _ = this;
      _.$U.showLoading(_);
      if (reload) {
        _.pagination.current = 1;
      } else {
        _.pagination.current = pagination.current;
      }
      const pageSize = pagination.pageSize || _.pagination.pageSize;
      _.pagination.pageSize = pageSize;

      const params = {
        ..._.cleanQueryInfo(_.queryInfo || {}),
        corpNo: _.$store?.state?.corpNo,
        pageNum: _.pagination.current,
        pageSize: _.pagination.pageSize,
      };

      _.$H.post(_, _.$A.activityOrder.axbActivityCommodityOrderList, params).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        _.tableData = payload?.content ?? payload?.list ?? payload?.records ?? [];
        _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
      }).catch(() => {
        _.tableData = [];
        _.pagination.total = 0;
      }).finally(() => {
        _.$U.hideLoading(_);
      });
    },
    pickCreateDate(time) {
      this.queryInfo.createFromTime = time ? time[0] : "";
      this.queryInfo.createToTime = time ? time[1] : "";
    },
    pickRefundDate(time) {
      this.queryInfo.refundFromTime = time ? time[0] : "";
      this.queryInfo.refundToTime = time ? time[1] : "";
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    handleEditOrView() {
      if (!this.checkSelectOne(this.selections)) {
        return;
      }
      const target = this.selections[0] || {};
      this.$router.push({
        name: "anxinPackDetail",
        query: {
          mode: "edit",
          orderNo: target.mapNo,
        },
      });
    },
    handleRefund() {
      if (!this.checkSelectOne(this.selections)) {
        return;
      }
      const target = this.selections[0] || {};
      if (target.refundResult === "SUCCESS") {
        this.$U.error("退款已完成,请勿重复提交");
        return;
      }
      const orderType = target.orderType || "";
      // if (orderType === "NEW_499_BUYOUT_ORDER") {
      //   this.selectedServiceType = "BUYOUT";
      // } else if (orderType === "NEW_499_PAY_ORDER") {
      //   this.selectedServiceType = "USE_PILE";
      // } else {
      //   this.$U.error("无法识别订单类型，请联系管理员");
      //   return;
      // }
      this.openRefundDialog();
    },
    confirmServiceType() {                              
      // 与参考页一致：当前页面通过订单类型自动判断，这里保留占位
      this.serviceTypeDialogVisible = false;
      this.openRefundDialog();
    },
    openRefundDialog() {
      const target = this.selections[0] || {};
      this.popFormInfo.refundAlipayAccount = target.mobile || target.orderNo || "";
      this.popFormInfo.custMobile = target.mobile || "";
      this.popFormInfo.mapNo = target.mapNo || "";
      this.popFormInfo.activityOrderNo = target.activityOrderNo || "";
      this.popFormInfo.orderName = target.orderName || "";

      const actualAmount = Number(target.actualAmount || 0) || 0;
      const refundAmount = Number(target.refundAmount ?? target.actualAmount ?? 0) || 0;
      const maxRefundAmount =
        Number.isFinite(actualAmount) && actualAmount > 0 ? actualAmount : Number.MAX_SAFE_INTEGER;

      this.popFormInfo.actualAmount = Number.isFinite(actualAmount) ? actualAmount : 0;
      this.popFormInfo.maxRefundAmount = Number.isFinite(maxRefundAmount)
        ? maxRefundAmount
        : Number.MAX_SAFE_INTEGER;
      this.popFormInfo.refundAmount = Math.min(refundAmount, this.popFormInfo.maxRefundAmount);
      this.popFormInfo.custAccount = target.mobile || "";
      this.popFormInfo.cancelAmount = Number(refundAmount) || 0;
      this.popFormInfo.cancelNo = target.cancelNo || "";

      Object.assign(this.popFormInfo, {
        resetUse: "N",
        refundType: "ALL",
        refundReason: "",
        refundRemark: "",
      });

      this.dialogVisible = true;
    },
    makeSure(formName) {
      const formRef = this.$refs[formName];
      if (!formRef || !formRef.validate) {
        this.$message.error("表单校验异常，请刷新后重试");
        return;
      }
      formRef.validate((valid) => {
        if (!valid) return;

        const target = this.selections[0] || {};
        const refundParams = {
          cancelNo: String(this.popFormInfo.cancelNo || target.cancelNo || ""),
          refundAmount: Number(this.popFormInfo.refundAmount || 0),
          activityOrderNo: String(this.popFormInfo.activityOrderNo || target.activityOrderNo || ""),
          refundReason: String(this.popFormInfo.refundReason || ""),
          refundType: String(this.popFormInfo.refundType || "ALL"),
          refundRemark: String(this.popFormInfo.refundRemark || ""),
          resetUse: String(this.popFormInfo.resetUse || "N"),
          mapNo: String(this.popFormInfo.mapNo || target.mapNo || ""),
          // 活动类型与活动类型明细:后端 newActivity/refund 用 findByTypeAndDetail 查活动配置,区分598/698
          // (商品订单DTO无activiryTypeDetail字段,按业务用 orderType 赋值)
          activityType: String(target.activityType || ""),
          activiryTypeDetail: String(target.orderType || ""),
        };

        const _ = this;
        _.$U.showLoading(_);
        _.$H.post(_, _.$A.activityOrder.axbNewActivityRefund, refundParams).then((res) => {
          const result = res?.data || {};
          if (result.status === 200 || result.code === 200) {
            _.$U.success("退款成功");
            _.dialogVisible = false;
            _.getListData(_.pagination, true);
          } else {
            _.$U.error(result.message || result.msg || "退款失败");
          }
        }).catch(() => {
          _.$U.error("退款请求失败，请稍后重试");
        }).finally(() => {
          _.$U.hideLoading(_);
        });
      });
    },
    handleClose(formName) {
      if (this.$refs[formName]?.resetFields) {
        this.$refs[formName].resetFields();
      }
      this.dialogVisible = false;
    },
    reset() {
      this.queryInfo = {};
      this.createTime = [];
      this.refundTime = [];
      this.getListData(this.pagination, true);
    },
    handleExport() {
      const _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6771";
      } else {
        urls = "http://192.168.8.174:7997";
      }

      _.$U.showLoading(_);
      const exportQueryInfo = {
        ..._.cleanQueryInfo(_.queryInfo || {}),
        corpNo: _.$store?.state?.corpNo,
        // activityExtendTypeEnum: "AXB_598_ACTIVITY_PAY",
      };
      _.$H.post(_, _.$A.activityOrder.axbActivityCommodityOrderListExcel, exportQueryInfo).then((res) => {
        if (res.data && res.data.data) {
          const data = res.data.data;
          if (data.base64 || data.fileName) {
            _.$U.saveExcelFile(data);
          }
          if (data.filePath) {
            let downUrl = data.filePath;
            if (!downUrl.startsWith("http")) {
              downUrl = urls + downUrl;
            }
            window.open(downUrl, "_blank");
          }
          _.$U.success("导出成功");
        } else {
          _.$U.error(res.data?.msg || res.data?.message || "导出失败：未获取到文件信息");
        }
        _.$U.hideLoading(_);
      }).catch((err) => {
        _.$U.hideLoading(_);
        // eslint-disable-next-line no-console
        console.error("导出失败:", err);
        _.$U.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || "导出失败");
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
